// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlist{border-radius:1em;overflow:hidden;height:92%;margin-top:4%;text-align:center}.imageRadius{border:5px solid #910048;width:100%;height:100%;border-radius:15px}.image{width:100%;height:100%;border-radius:15px}.playlistName{position:absolute;top:42%;left:10%;right:5%;color:white;display:inline-block;font-size:1.8rem;line-height:1.8rem}\n", ""]);
// Exports
module.exports = exports;
